import React from 'react';
import { useSearchParams } from 'react-router-dom';

import client from '../../../services/knowledge-api';
import * as API from '../../../constants/api';

import useCustomPagination from '../../../hooks/useCustomPagination';
import { useSwrPageRequestKeysManagingWithContextSaving } from '../../../hooks/useSwrPageRequestKeysManagingWithContextSaving';

import { VIEW_TYPES } from '../../../constants/viewTypes';
import { useViewType } from '../../../hooks/useViewType';

import { BASE_TYPE } from '../../../constants/base';
import { SORT_TYPES } from '../../../constants/sort';
import { parseSearchParams } from '../../../helpers/parseSearchSortPageSearchParams';

import Loading from '../../../components/Loading';
import BasesList from '../BasesList/BasesList';
import BasesEmptyView from '../BasesEmptyView/BasesEmptyView';

const BasesIndex = () => {
    const [searchParams] = useSearchParams();
    const parsedParams = parseSearchParams(searchParams);

    const page = parsedParams.page || 1;

    const queryParams = { ordering: parsedParams.sort || SORT_TYPES.created };
    if (parsedParams.search) {
        queryParams.search = parsedParams.search;
    }

    const basesHookResponse = useCustomPagination({
        client,
        route: API.ROUTES.knowledge.base,
        pageIndex: page - 1,
        searchParams: queryParams,
        autoFetchNextPage: true,
    });
    const { data, total, loading, key, nextPageKey } = basesHookResponse;

    const { requestKeysToMutate } = useSwrPageRequestKeysManagingWithContextSaving({
        pageAccessor: 'bases',
        key,
        nextPageKey,
    });

    if (!total && loading) {
        return (
            <div className="pt-2">
                <Loading />
            </div>
        );
    }

    const emptyStateShown = !total && !data?.length && !loading;

    if (emptyStateShown) {
        return <BasesEmptyView isSearchQuery={parsedParams.search} />;
    }

    return (
        <BasesList
            basesHookResponse={basesHookResponse}
            requestKeysToMutate={requestKeysToMutate}
            page={page}
        />
    );
};

export default BasesIndex;
